import { ClockIcon } from '@heroicons/react/24/outline';
import { getActiveTimezoneInfo } from '../utils/formatDateTime';

/**
 * Small badge that tells the user which timezone the surrounding timestamps
 * are rendered in. Use it next to page titles whenever the page shows times
 * (alerts feed, reports, incidents, etc.) so users on different clocks know
 * which site clock they're reading.
 */
export default function TimezonePill({ className = '' }) {
  const { timezone, abbr } = getActiveTimezoneInfo();
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full bg-blue-50 text-blue-700 border border-blue-200 ${className}`}
      title={`All times shown in ${timezone}`}
    >
      <ClockIcon className="w-3.5 h-3.5" />
      Times in {abbr}
    </span>
  );
}
